import React from 'react';
import { SettingsContent } from '../../components/settings/SettingsContent';
import { usePageTitle } from '../../hooks/usePageTitle';

const IdeaMachineSettings = () => {
  usePageTitle('Idea Machine');
  
  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white mb-6">Settings</h1>
      
      {/* Reusable Settings Content */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border dark:border-gray-700">
        <SettingsContent showProfilePicture={true} />
      </div>
    </div>
  );
};

export default IdeaMachineSettings;